import React from 'react';
import PrivateRoute from './PrivateRoute';
import { getPathApp } from '../utils/util';
import DeliveryRouteLocationTarget from '../containers/Expedition/Delivery/DeliveryRoute/RouteLocationTarget/DeliveryRouteLocationTarget'
import DeliveryRouteLocationTargetList from '../containers/Expedition/Delivery/DeliveryRoute/RouteLocationTarget/DeliveryRouteLocationTargetList'
import Home from '../containers/Expedition/Delivery/DeliveryRoute/Home'

let aux = 0;
const pathurl = getPathApp(window);

const RouteDeliveryRoute = [
    <PrivateRoute key={aux += 1} path={`${pathurl}/deliveryroute/routelocationtarget/list`} component={DeliveryRouteLocationTargetList} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/deliveryroute/routelocationtarget/insert`} component={DeliveryRouteLocationTarget} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/deliveryroute/home`} component={Home} />
];

export default RouteDeliveryRoute;